<div class="container-fluid">
    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}">
        @if(this.userAuthService.checkPermission('MANAGE.RELEASE.AUDIT.VIEW') && enableAuditTrail)
        {
        <div header-right>
            <div class="header-right-section">
                <button class="mdc-button mdc-button--raised mdc-button--sharp ripple-material audit-trail-link"
                    type="button" (click)="navigateToAuditTrail()" [disabled]="readonlyMode"
                    matTooltip="View Audit Trail" matTooltipClass="ey-custom-tooltip" matTooltipPosition="below">
                    <span class="mdc-button__ripple"></span>
                    Audit Trail
                </button>
            </div>
        </div>
        }
    </app-page-header>

    <div class="material-form-controls ">
        <form [formGroup]="form" validateOnSubmit autocomplete="off" id="releaseHotfixForm">
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="fill" class="w-100" >
                        @if(hotfixId){
                        <mat-label>Release Prefix</mat-label>
                        }@else{
                        <mat-label>Enter Release Prefix</mat-label>
                        }                        
                        <input matInput type="text" maxlength="50" autocomplete="off" formControlName="releasePrefix"
                            required (paste)="on_paste_omit_special_char($event, 'releasePrefix')"
                            (keypress)="omit_special_char($event, true)" aria-labelledby="my-label-releasePrefix"
                            aria-describedby="my-helper-releasePrefix"   [readonly]="hideField"/>
                        <mat-icon style="font-size: 18px; height:20px;" matSuffix
                            matTooltip="{{ configReleaseNameInfoMsg }}" matTooltipPosition="right"
                            matTooltipClass="ey-custom-tooltip" aria-hidden="true">info</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 m-b-6">

                </div>

                <div class="col-sm-6">
                    <mat-form-field appearance="fill" class="w-100" >
                        @if(hotfixId){
                        <mat-label>Release Name</mat-label>
                        }@else{
                        <mat-label>Enter Release Name</mat-label>
                        } 
                        <input matInput type="text" maxlength="50" autocomplete="off" formControlName="releaseName"
                            required (paste)="on_paste_omit_special_char($event, 'releaseName', [32])"
                            (keypress)="omit_special_char($event, true, [32])" aria-labelledby="my-label-releaseName"
                            aria-describedby="my-helper-releaseName"  [readonly]="hideField" />
                        <mat-icon style="font-size: 18px; height:20px;" matSuffix
                            matTooltip="{{ configReleaseNameInfoMsg }}" matTooltipPosition="right"
                            matTooltipClass="ey-custom-tooltip" aria-hidden="true">info</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 m-b-6"></div>
                
                <div class="col-sm-6">

                <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Release Type</mat-label>
                    <mat-select formControlName="selectedVersionType" required aria-labelledby="my-label-releaseName"
                        aria-describedby="my-helper-releaseName" panelClass="releaseForm-environments-custom-panel"
                        (selectionChange)="setBranchNamebyReleaseId()" [disabled]="hideField">
                        <mat-option *ngFor="let version of defaultVersionTypeList" [value]="version.value">
                            {{ version.label }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix matTooltip="{{ configVersionTypeInfoMsg }}" matTooltipPosition="right"
                        aria-hidden="true" matTooltipClass="ey-custom-tooltip">info</mat-icon>
                </mat-form-field>
            </div>
            <div class="col-sm-6 m-b-6"></div>
              @if(hotfixId){
            <div class="col-sm-6">
                    <mat-form-field appearance="fill" class="w-100">
                        @if(hotfixId){
                        <mat-label>Parent Release Name</mat-label>
                        }
                        <input matInput type="text" maxlength="50" autocomplete="off" formControlName="parentReleaseName" required
                            (paste)="on_paste_omit_special_char($event, 'parentReleaseName')"
                            (keypress)="omit_special_char($event, true)" aria-labelledby="my-label-parentReleaseName"
                            aria-describedby="my-helper-parentReleaseName" [readonly]="true" />
                        <mat-icon style="font-size: 18px; height:20px;" matSuffix matTooltip="{{ parentReleaseNameInfoMsg }}"
                            matTooltipPosition="right" matTooltipClass="ey-custom-tooltip" aria-hidden="true">info</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 m-b-6"></div>
            }
                <div class="col-sm-6 m-b-6">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Select Environments</mat-label>
                        <mat-select formControlName="environments" multiple (selectionChange)="onEnvironmentChange()"
                            panelClass="releaseForm-environments-custom-panel">
                            <!-- Select All Checkbox -->
                            <mat-option
                                [ngClass]="{'h-72': filteredEnvironmentsMulti && environmentsList && environmentsList.length>0 && (filteredEnvironmentsMulti | async).length==0}">
                                <ngx-mat-select-search ngDefaultControl [showToggleAllCheckbox]="true"
                                    (toggleAll)="toggleSelectAll($event)"
                                    [toggleAllCheckboxChecked]="allElementsSelected"
                                    [toggleAllCheckboxIndeterminate]="anyElementsSelected"
                                    [formControl]="environmentsFilterCtrl"
                                    [toggleAllCheckboxTooltipMessage]="tooltipMessage" noEntriesFoundLabel="Not found"
                                    [toggleAllCheckboxTooltipPosition]="'above'"
                                    placeholderLabel="Search Environments"></ngx-mat-select-search>
                            </mat-option>
                            <!-- Environment options -->
                            <mat-option *ngFor="let env of filteredEnvironmentsMulti | async" [value]="env">
                                {{ env.value }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix matTooltip="{{ configEnvInfoMsg }}" matTooltipPosition="right"
                            aria-hidden="true" matTooltipClass="ey-custom-tooltip">info</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 m-b-6"></div>
                <div id="serviceSelect" class="col-sm-12 m-b-10">
                    <div class="row">
                        <label for="serviceSelect" class="label-position">
                            Select Services <span>*</span>
                        </label>

                        <span class="info-icon" [matTooltip]="configSerInfoMsg" placement="bottom"
                            matTooltipPosition="right" matTooltipClass="ey-custom-tooltip">
                            <i class="mr-0 fs-18 material-icons material-icons-info" aria-hidden="true">info</i>
                        </span>

                    </div>
                    <div class="card">
                        <p-table [value]="releaseServicesList" dataKey="code">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th id="select-checkbox">
                                        <mat-checkbox name="allSelected" [ngModelOptions]="{standalone: true}"
                                            class="fids-primary-checkbox" type="checkbox" [ngClass]="{'checkbox-disabled':  isEnvironmentMissing(),
                                        'checkbox-enabled': !(isEnvironmentMissing())}" [(ngModel)]="allSelected"
                                            [disabled]="isEnvironmentMissing() || readonlyMode"
                                            [indeterminate]="isIndeterminate" (change)="toggleAllRows()">
                                        </mat-checkbox>

                                    </th>
                                    <th id="service_Name">Service Name</th>

                                    <th id="release_branch_name">Source Branch <span>*</span>
                                        <span class="info-icon-grid" [matTooltip]="configReleaseBranchNameInfoMsg"
                                            placement="bottom" matTooltipPosition="right"
                                            matTooltipClass="ey-custom-tooltip">
                                            <i style="font-size: 18px;text-align: center;" class="mr-0 fs-18 material-icons"
                                                aria-hidden="true">info</i>
                                        </span>
                                    </th>
                                    <th id="version_Number">Version Number<span>*</span>
                                        <span class="info-icon-grid" [matTooltip]="configVersionNumberInfoMsg"
                                            placement="bottom" matTooltipPosition="right"
                                            matTooltipClass="ey-custom-tooltip">
                                            <i style="font-size: 18px;text-align: center;" class="mr-0 fs-18 material-icons"
                                                aria-hidden="true">info</i>
                                        </span>
                                    </th>
                                    <th id="environments">Environments
                                        <span class="info-icon-grid" [matTooltip]="configEnvironmentsInfoMsg"
                                            placement="bottom" matTooltipPosition="right"
                                            matTooltipClass="ey-custom-tooltip">
                                            <i style="font-size: 18px;text-align: center;" class="mr-0 fs-18 material-icons"
                                                aria-hidden="true">info</i>
                                        </span>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-row>
                                <tr [ngClass]="{'disabledRow': row.isAlreadyExist === true}">
                                    <td>
                                        <mat-checkbox name="row.isSelected" class="fids-primary-checkbox"
                                            [ngModelOptions]="{standalone: true}"
                                            [disabled]="row.isAlreadyExist === true || isEnvironmentMissing() || readonlyMode"
                                            [ngClass]="{
                                                    'checkbox-disabled': row.isAlreadyExist === true || isEnvironmentMissing(),
                                                    'checkbox-enabled': !(row.isAlreadyExist === true || isEnvironmentMissing())
                                                }" (change)="onRowCheckboxChange()" type="checkbox"
                                            [(ngModel)]="row.isSelected">
                                        </mat-checkbox>
                                    </td>
                                    <td>{{ row.serviceName }}</td>

                                    <td>
                                        <input pInputText type="text" [disabled]="true" [(ngModel)]="row.branchName"
                                            [ngModelOptions]="{standalone: true}"
                                            class="p-inputtext p-component p-element ng-untouched ng-pristine p-filled"
                                            (keypress)="omit_special_char($event, false)" />
                                    </td>
                                    <td>
                                        <input pInputText type="text"  [disabled]="true" [(ngModel)]="row.versionNumber"
                                            [ngModelOptions]="{standalone: true}"
                                            class="p-inputtext p-component p-element ng-untouched ng-pristine p-filled"
                                            (keypress)="omit_special_char($event, false)" />
                                    </td>
                                    <td>
                                        <textarea  pInputText [(ngModel)]="row.mappedServiceNames" rows="2" cols="30" class="w-100"
                                            [ngModelOptions]="{standalone: true}"
                                            class="p-inputtext p-component p-element ng-untouched ng-pristine p-filled"
                                            [disabled]="true"></textarea>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                </div>


                <div class="col-sm-12 m-t-20 m-b-20 text-center">
                    <button class="mdc-button ripple-material" (click)="cancel()" type="button">
                        <span class="mdc-button__ripple"></span> Cancel
                    </button>
                    &nbsp;
                    <button class="mdc-button mdc-button--raised mdc-button--sharp ripple-material"
                        [disabled]="isInvalidForm() || readonlyMode" (click)="save()" type="button" #submitButton>
                        <span class="mdc-button__ripple"></span> Save Changes
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>